import { Button, Input, Space, TableProps } from "antd";
import { useEffect } from "react";
import AddIcon from "../../../../assets/icons/AddIcon";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import SearchIcon from "../../../../assets/web/icons/SearchIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useDeleteWalletTagMutation,
  useGetAllWalletTagQuery,
} from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import ConfirmModalLayout from "../../../../layouts/ConfirmModalLayout";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import { toast } from "../../../../lib/toast";
import {
  GetAllWalletTagDataType,
  GetAllWalletTagParamsType,
} from "../../../../types/portal/companyOnboard";
import { countParPageSerialNumber } from "../../../../utils/number";
import { capitalize } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";
import AddWalletTagModal from "./AddWalletTagModal";

export default function WalletTagsList() {
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllWalletTagParamsType>();

  const { open, handleOpen, handleClose } = useModal();
  const {
    open: openConfirmDeleteModal,
    handleOpen: handleConfirmDeleteOpen,
    handleClose: handleConfirmDeleteClose,
  } = useModal<any, "CONFIRM">();

  const {
    data: getAllWalletTagData,
    isError: getAllWalletTagIsError,
    error: getAllWalletTagError,
    isLoading: getAllWalletTagIsLoading,
  } = useGetAllWalletTagQuery({
    params: {
      search: keyword,
      page,
      limit,
    },
  });

  const [
    deleteWalletTag,
    {
      isError: deleteWalletTagIsError,
      error: deleteWalletTagError,
      isLoading: deleteWalletTagIsLoading,
      isSuccess: deleteWalletTagIsSuccess,
    },
  ] = useDeleteWalletTagMutation();

  const handleSendToApprove = () => {
    const id = openConfirmDeleteModal?.data?.id;

    if (id) {
      deleteWalletTag(id);
    }
  };

  useError(getAllWalletTagIsError, getAllWalletTagError, "Get wallet tag fail");
  useError(getAllWalletTagIsError, getAllWalletTagError, "Get wallet tag fail");
  useError(
    deleteWalletTagIsError,
    deleteWalletTagError,
    "Delete wallet tag fail"
  );
  useEffect(() => {
    if (deleteWalletTagIsSuccess) {
      toast("success", "Tags deleted successfully");
      handleConfirmDeleteClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteWalletTagIsSuccess]);

  const leaveSettingsTabList = [
    {
      label: "Wallets",
      link: `/admin/sheba-pay-wallet`,
    },
    // {
    //   label: "Tags",
    //   link: `/admin/sheba-pay-wallet/wallet-tags`,
    // },
  ];

  const columns: TableProps<GetAllWalletTagDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Tag Name</div>,
      dataIndex: "name",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Wallet Used</span>,
      dataIndex: "wallet_count",
      align: "center",
      render: (val) => (val ? val : "0"),
    },
    {
      title: <span className="whitespace-nowrap">Created At</span>,
      align: "center",
      dataIndex: "created_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      render: (val, record: any) => (
        <Space size={8}>
          <Button
            icon={<EditIcon />}
            size="small"
            className="action-button"
            danger
            onClick={() => handleOpen({ type: "UPDATE", data: val })}
          />

          <Button
            icon={<DeleteIcon />}
            size="small"
            className="action-button !bg-[#FFFFFF]"
            danger
            onClick={() =>
              handleConfirmDeleteOpen({ type: "CONFIRM", data: record })
            }
            disabled={record?.wallet_count > 0}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <SidebarLayout title="Sheba Pay Wallet" tabList={leaveSettingsTabList}>
        <CustomTable
          loading={getAllWalletTagIsLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={getAllWalletTagData?.data?.totalLength ?? 0}
          dataSource={addKeyInArray(getAllWalletTagData?.data?.tags ?? [])}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search Tag"
                className="!min-w-[60px]"
                allowClear
                onChange={handleSearch}
              />

              <Button
                icon={<AddIcon />}
                onClick={() => handleOpen({ type: "ADD" })}
                className=""
                type="primary"
                size="middle"
              >
                New Tag
              </Button>
            </>
          }
        />
      </SidebarLayout>

      {open?.type === "ADD" || open?.type === "UPDATE" ? (
        <AddWalletTagModal
          open={open?.open}
          handleClose={handleClose}
          data={open?.data}
          type={open?.type}
        />
      ) : null}

      {openConfirmDeleteModal?.type === "CONFIRM" && (
        <ConfirmModalLayout
          title="Confirm Action"
          subTitle={`Are you sure you want to delete the tag "${openConfirmDeleteModal?.data?.name}"?`}
          buttonName="Yes, Delete"
          handleButton={handleSendToApprove}
          open={openConfirmDeleteModal?.open}
          handleClose={handleConfirmDeleteClose}
          action
          buttonBgDeep
          loading={deleteWalletTagIsLoading}
        ></ConfirmModalLayout>
      )}
    </>
  );
}
